"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
// const Vendor: React.FC<Props> = ({ item }) => item.rechVendor ? <LogoAndName brand={item.rechVendor} size="sm_plus" /> : null;
var Vendor = function (_a) {
    var _b;
    var item = _a.item;
    return (0, jsx_runtime_1.jsx)(LogoAndName_1.default, { brand: (_b = item.rechVendor) !== null && _b !== void 0 ? _b : { name: 'No vendor' }, size: "sm_plus" });
};
exports.default = Vendor;
